import React, { useRef, useEffect, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { CSVLink } from 'react-csv';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal, faFileCsv } from '@fortawesome/free-solid-svg-icons';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagemFichas from '../../../components/TabelaListagemFichas/TabelaListagemFichas';

//Context
import { useAuth } from '../../../context/auth';


export default function RelatorioRankingDeDestinos({ btnVoltar, dadosRanking, filtros }) {
    const { setupVariavel, session } = useAuth();

    //Variavel que guarda os dados organizados para gerar o csv
    const [dadosCSV, setDadosCSV] = useState([]);

    //Cabeçalhos da tabela de ranking
    const headers = [
        { value: "Destinos", objectValue: "destino" },
        { value: "Recebido", objectValue: "destinado" },
    ]
    //Referencia do relatorio
    const refRelatorio = useRef();

    //Referencia do relatorio para download do csv
    const exportRef = useRef(null);

    //Botão de exportação csv
    const BtnExportCsv = () => {
        return (
            <Button className='mb-3' color='success' onClick={() => exportRef.current.link.click()}>
                <FontAwesomeIcon icon={faFileCsv} /> Gerar CSV
            </Button>
        )
    }
    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Ranking de destinos",
    });

    //Carrega os dados do relatorio csv
    useEffect(() => {
        const headersCSV = headers.map(value => value.value);
        const corpoCSV = dadosRanking.ranking.map(value => {
            const data = [];
            headers.map(header => {
                data.push(value[header.objectValue]);
            });
            return data;
        });
        const footerCSV = ["Quantidade de destinos: " + dadosRanking.ranking.length, "Total Recebido: " + dadosRanking.totalDestinado];
        setDadosCSV([headersCSV, ...corpoCSV, footerCSV]);
    }, []);

    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint} BtnAction1InTop={BtnExportCsv}>
            <CSVLink separator={";"} data={dadosCSV} filename="Ranking de destinos.csv" target="_blank" ref={exportRef}></CSVLink>
            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%'}}  />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Ranking de destinos</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                    </Row>
                    <Row>
                        <div className='col-4'>
                            {filtros.modalidadeId_selected
                                ?
                                <p><span className="fw-bold">Modalidade:</span> {filtros.modalidadeId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Modalidade:</span> Todos</p>
                            }
                        </div>
                    </Row>
                </div>
                <div className='m-2 body' style={{ color: "#666" }}>
                    <h5 className="bg-gradient bg-secondary p-2 rounded-3 text-light subtitleCardInfo"><FontAwesomeIcon icon={faMedal} className="me-2" /> Tabela de ranking</h5>

                    <TabelaListagemFichas headers={headers} items={dadosRanking.ranking} scrollbar={false} />

                    <h6 className="mt-4 text-center  bg-secondary p-2 rounded-3 text-light subtitleCardInfo">Quantidade de destinos: {dadosRanking.ranking.length} | Total Recebido: {dadosRanking.totalDestinado} kg</h6>
                </div>
            </div >
        </MainCard >
    )
}